import {Injectable} from '@angular/core';
import {Crud} from './crud';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrudTitlesService extends Crud {

  createEntity(entityjson: {}): Observable<any> {
    const formData = new FormData();
    formData.append('entity', JSON.stringify(entityjson));
    const url = '/v1/admin/titles';
    return this.http.post(this.serverRoot + url, formData);
  } // createEntity

  getEntity(id: string = ''): Observable<any> {
    const url = '/v1/admin/titles/' + id;
    return this.http.get(this.serverRoot + url);
  } // getEntity

  getEntities(): Observable<any> {
    const url = '/v1/admin/titles';
    return this.http.get(this.serverRoot + url);
  } // getEntities

  updateEntity(id: string = '', entityjson: {}): Observable<any> {
    const formData = new FormData();
    formData.append('entity', JSON.stringify(entityjson));
    const url = '/v1/admin/titles/' + id;
    return this.http.post(this.serverRoot + url, formData);
  } // updateEntity

  removeEntity(id: string = ''): Observable<any> {
    const url = '/v1/admin/titles/' + id;
    return this.http.delete(this.serverRoot + url);
  } // removeEntity

}
